module.exports = __webpack_public_path__ + "img/templeofset_tech_Normal_ua.7ee2ad72.webp";